// @flow
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import Apple from '../components/Apple';

function mapDispatchToProps(dispatch: Function) {
  return bindActionCreators({ goToRedirect: (route: string) => push(route) }, dispatch);
}

export default connect(null, mapDispatchToProps)(Apple);



// WEBPACK FOOTER //
// ./src/modules/apple/containers/AppleContainer.js